import { LegalEntityDeletionBlockerType } from "./DeleteLegalEntityBlockedDialog.types.ts";

export const legalEntityBlockerTranslationKeys: Record<LegalEntityDeletionBlockerType, string> = {
    [LegalEntityDeletionBlockerType.Asset]: "systems",
    [LegalEntityDeletionBlockerType.ProcessingActivity]: "processingActivities",
    [LegalEntityDeletionBlockerType.Contract]: "contracts",
    [LegalEntityDeletionBlockerType.SubContractorOf]: "deletionBlockerSubContractorOf",
    [LegalEntityDeletionBlockerType.AuditSender]: "deletionBlockerAuditSender",
    [LegalEntityDeletionBlockerType.PublicInternalAssessmentTemplate]: "deletionBlockerPublicInternalAssessmentTemplates",
    [LegalEntityDeletionBlockerType.InternalAssessment]: "internalAssessments",
    [LegalEntityDeletionBlockerType.AuditGroup]: "auditGroups",
    [LegalEntityDeletionBlockerType.AnnualWheelActivity]: "annualWheelActivities",
    [LegalEntityDeletionBlockerType.Task]: "tasks",
    [LegalEntityDeletionBlockerType.DocumentAccess]: "deletionBlockerDocumentAccess",
    [LegalEntityDeletionBlockerType.InternalAssessmentAssignee]: "deletionBlockerInternalAssessmentAssignee",
    [LegalEntityDeletionBlockerType.InternalAssessmentGroup]: "deletionBlockerInternalAssessmentGroups",
    [LegalEntityDeletionBlockerType.Process]: "processes",
};

// Only the access filtered blockers can leave the user without access to some of their items.
export const legalEntityBlockerNoAccessTranslationKeys: Partial<Record<LegalEntityDeletionBlockerType, string>> = {
    [LegalEntityDeletionBlockerType.Asset]: "deletionBlockerNoAccessAssets",
    [LegalEntityDeletionBlockerType.ProcessingActivity]: "deletionBlockerNoAccessProcessingActivities",
    [LegalEntityDeletionBlockerType.Contract]: "deletionBlockerNoAccessContracts",
    [LegalEntityDeletionBlockerType.Task]: "deletionBlockerNoAccessTasks",
    [LegalEntityDeletionBlockerType.Process]: "deletionBlockerNoAccessProcesses",
};
